// extracted by mini-css-extract-plugin
module.exports = {"wrap":"SplitButton_wrap_1ZJJa","left":"SplitButton_left_22FEk","right":"SplitButton_right_2C0PL","inactive":"SplitButton_inactive_SmCY3","faTimes":"SplitButton_faTimes_FQkQp"};